module.exports = __webpack_public_path__ + "static/assets/8ee488efc547b536f41efe53e4ac7a7a.png";